import { createSlice } from "@reduxjs/toolkit";
import { format } from "date-fns";
import { signInUser } from "../Components/Utility/Auth";

const user = signInUser();

const intialState = {
  // _id: string,
  grnNo: "",
  poNo: null,
  poId: null,
  warehouse: user?.warehouse,
  tpnNo: null,
  supplier: null,
  products: [],
  type: "",
  note: "",
  doc: "",
  totalItem: 0,
  total: 0,
  grossTotal: 0,
  discount: 0,
  tax: 0,
  userId: user?.id,
  voucherNo: "",
  voucherDate: format(new Date(), "yyyy-MM-dd") + "T00:00:00.000+00:00",
  shipping_cost: 0,
  print: false,
  aamarId: user?.aamarId,
  status: "Complete",
};
export const grnSlice = createSlice({
  name: "grn",
  initialState: intialState,
  reducers: {
    selectSupplier: (state, action) => {
      return { ...state, supplier: action.payload };
    },
    selectWareHouse: (state, action) => {
      return { ...state, warehouse: action.payload };
    },
    selectPoNo: (state, action) => {
      return { ...state, poNo: action.payload.id, poId: action.payload.no };
    },
    selectTPNNo: (state, action) => {
      return { ...state, tpnNo: action.payload.id };
    },
    selectUser: (state, action) => {
      return { ...state, userId: action.payload };
    },
    selectProducts: (state, action) => {
      return { ...state, products: action.payload };
    },
    selectNote: (state, action) => {
      return { ...state, note: action.payload };
    },
    selectShipping: (state, action) => {
      return { ...state, shipping_cost: action.payload };
    },
    selectDiscount: (state, action) => {
      return { ...state, discount: action.payload };
    },
    // selectAamarId: (state, action) => {
    //   return { ...state, aamarId: action.payload };
    // },
    selectStatus: (state, action) => {
      return { ...state, status: action.payload };
    },
    selectVoucherNo: (state, action) => {
      return { ...state, voucherNo: action.payload };
    },
    selectVoucherDate: (state, action) => {
      const formattedDate = format(new Date(action.payload), "yyyy-MM-dd");
      return { ...state, voucherDate: formattedDate + "T00:00:00.000+00:00" };
    },
    selectNewPrice: (state, action) => {
      console.log(state.products);
      const selected = state.products.find((p) => p.id === action.payload.id);
      const rest = state.products.filter((p) => p.id !== action.payload.id);
      return {
        ...state,
        products: [
          ...rest,
          {
            ...selected,
            newPrice: false,
            priceId: action.payload.priceId,
          },
        ],
      };
    },
    selectCalculation: (state, action) => {
      return {
        ...state,
        totalItem: Number(action.payload.totalItem),
        total: Number(action.payload.total),
        tax: Number(action.payload.tax),
        grossTotal: Number(action.payload.groundTotal),
      };
    },
    resetGrn: () => intialState,
  },
});

export const {
  selectSupplier,
  selectWareHouse,
  selectUser,
  selectProducts,
  selectNote,
  selectDiscount,
  selectCalculation,
  selectAamarId,
  selectStatus,
  selectShipping,
  resetGrn,
  selectPoNo,
  selectTPNNo,
  selectVoucherNo,
  selectVoucherDate,
  selectNewPrice,
} = grnSlice.actions;
export const grnReducer = grnSlice.reducer;
